module.exports = {
  title: 'GENESIS',
  baseUrl: 'http://www.genesischain.io', // 项目地址
  // baseApi: 'http://m.okcashcoin.com/api/', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  baseApi: 'https://api.genesischain.io/api/', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: 'http://api.genesischain.io/api'
}
